import * as c from '../../../../../../constants.jsx';
import NewbornPanelsCardTemplate from '../../../../../../components/CockpitCards/NewbornPanelsCardTemplate.jsx';

export default function MetabolicNewbornCard() {

return(
<>

<NewbornPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/metabolicnewborn`}

  panel_name = { "METABOLIC DISORDERS" }
  panel_subtext = {"ORGANIC ACID CONDITIONS - This panel is based on the Recommended Uniform Screening Panel (RUSP), a list of conditions selected by experts for newborn screening programs."}

/>

</> 
)}

